// removed by extract-text-webpack-plugin
module.exports = {"container":"_2SlU4laPwLw6mMhXXObh5d","title":"hcHuncP6ga4bGiRhns3fc","btnBlock":"_2ztNUFlPbIfIpAqLOqjJ4k","btnQuit":"_2mChWiDKSZu9ZDfVOVOdUH","btnDisable":"_3zdclBFGRpStePCJ4F1Fau"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Admin/UserInformation/styles.css
// module id = 3155
// module chunks = 0